"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = __importDefault(require(".."));
var immer_1 = __importDefault(require("immer"));
var util_1 = require("util");
var set_1 = __importDefault(require("lodash/set"));
var applyDeltaToEntities = function (viewConfig, entities, delta, baseRecord, errorOnNonConfiguredFields) {
    if (errorOnNonConfiguredFields === void 0) { errorOnNonConfiguredFields = true; }
    return (0, immer_1.default)(entities, function (draftEntities) {
        Object.entries(delta)
            // do the shorter paths first so that longer paths that depend on it can be set up
            .sort(function (_a, _b) {
            var path1 = _a[0];
            var path2 = _b[0];
            return path1.length - path2.length;
        })
            .forEach(function (_a) {
            var _path = _a[0], newValue = _a[1];
            // change the reference to another record, (never mutate a record id).
            var path = _path.endsWith('.id') ? "".concat(_path.slice(0, -3), "Id") : _path;
            var pathToRecordWeWillWriteChangeTo = path.includes('.') ? path.slice(0, path.lastIndexOf('.')) : '';
            var writePathFromRecord = path.includes('.') ? path.slice(path.lastIndexOf('.') + 1) : path;
            (0, __1.default)(viewConfig, pathToRecordWeWillWriteChangeTo, baseRecord, draftEntities, errorOnNonConfiguredFields).foldL(function () {
                /*
                console.log(
                    'missed pathToRecord: ',
                    pathToRecordWeWillWriteChangeTo,
                    'writePath',
                    writePathFromRecord,
                );
                */
                return null;
            }, function (draftRecord) {
                if (draftRecord && (0, util_1.isObject)(draftRecord)) {
                    (0, set_1.default)(draftRecord, writePathFromRecord, newValue);
                    if (writePathFromRecord.endsWith('Id')) {
                        // set the link normalizer uses
                        (0, set_1.default)(draftRecord, writePathFromRecord.slice(0, -2), newValue);
                    }
                }
                else {
                    // something went wrong.
                }
            });
        });
    });
};
exports.default = applyDeltaToEntities;
//# sourceMappingURL=index.js.map